import styled from 'styled-components'
import { Column, Row } from 'components/common/layout'
import { BaseText, H5Text, MediumText, SmallText } from 'components/common/text'
import { BtnSize, BtnType, Button } from 'components/common/button'
import { textEllipsis } from 'components/common/styles'
import { ShadowCard } from 'components/common/card'

export const DashboardChatItemTypeText = styled(MediumText)`
  font-size: 11px;
  color: ${(p) => p.theme.color.gray1};
`

export const ChatRoomTopMainContainer = styled(Column)`
  gap: 16px;
  padding: 16px;
  border-top: 1px solid ${(p) => p.theme.color.line};
  border-bottom: 1px solid ${(p) => p.theme.color.line};
`

export const OverflowHiddenText = styled(BaseText)`
  ${textEllipsis}
`

export const ChatListItemBox = styled(Column)<{ isSelected: boolean }>`
  gap: 8px;
  padding: 16px;
  background-color: ${(p) => p.theme.color.white1};
  border-bottom: 1px solid ${(p) => p.theme.color.line};
  ${(p) => p.isSelected && `background-color: ${p.theme.color.background}`};
  cursor: pointer;
`

export const ChatListItemSubText = styled(BaseText)`
  flex: none;
  font-size: 11px;
  color: ${(p) => p.theme.color.gray2};
`

export const ChatListItemNameText = styled(OverflowHiddenText)`
  font-size: ${(p) => p.theme.fontSize.desc};
  font-weight: ${(p) => p.theme.fontWeight.medium};
`

export const ChatListItemLastMessageText = styled(SmallText)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(p) => p.theme.color.gray1};
`

export const SpaceBetween = styled(Row)`
  justify-content: space-between;
`

export const ChatInfoMainContainer = styled(Column)`
  position: relative;
  padding: 16px;
  gap: 40px;
`

export const ChatInfoHeader = styled(Row)`
  top: 0;
  z-index: 1;
  position: sticky;
  justify-content: end;
  padding: 8px 8px 0;
`

export const ChatFunctionContainer = styled(ShadowCard)`
  gap: 8px;
  padding: 4px;
  flex-direction: row;
  align-items: center;
  border: 1px solid ${(p) => p.theme.color.line};
`

export const ChatInfoSection = styled(Column)`
  gap: 16px;
`

export const ChatInfoSectionText = styled(H5Text)`
  font-weight: ${(p) => p.theme.fontWeight.semiBold};
  span {
    color: ${(p) => p.theme.color.primary};
  }
`

export const Dimmed = styled.div`
  z-index: 99;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
`

export const FullScreenDimmed = styled(Dimmed)`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
`

export const SmallButton = styled(Button).attrs({
  size: BtnSize.SMALL,
  variant: BtnType.PRIMARY2,
})`
  width: 'fit-content';
  padding: 4px 8px;
`

export const ChatToolbarWrapper = styled(Column)`
  padding: 16px;
  gap: 8px;
  background-color: ${(p) => p.theme.color.white1};
  border-top: 1px solid ${(p) => p.theme.color.line};
  @media ${(p) => p.theme.deviceSize.mobile} {
    padding: 8px 16px 16px;
  }
`
